import React from 'react';

export const useAutoFocus = (timeout = 0) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus?.();
    }, timeout);
  }, []);

  return inputRef;
};
